export default __webpack_public_path__ + "static/media/news64.73b350f1.jpg";